<template>
  <div class="about">
    <div class="about-banner">
      <div class="container">
        <h1 class="about-banner__title">About</h1>
      </div>
    </div>
    <div class="about-body">
      <div class="container">
        <el-tabs
          v-model="activeName"
          class="about-tabs"
          type="card"
          @tab-click="handleTabClick"
        >
          <el-tab-pane
            label="About the research team"
            name="AboutTheResearchTeam"
          >
            <p class="about-title">
              <span class="about-title__name">Team introduction</span>
              <span class="about-title__time">Established: 2014.04</span>
            </p>
            <div class="about-wechat">
              <div class="about-wechat__card">
                <div class="about-wechat__card-body">
                  <div class="about-wechat__card-logo">
                    <img
                      alt="WeChat official account logo"
                      src="@/assets/about/logo.webp"
                    />
                  </div>
                  <div class="about-wechat__card-title">
                    <h3>智繁Ye茂</h3>
                  </div>
                </div>
                <div class="about-wechat__card-footer">
                  WeChat official account
                </div>
              </div>
              <div class="about-divider"></div>
              <div class="about-qrcode">
                <img
                  alt="WeChat official account"
                  src="@/assets/about/WeChat official account.webp"
                />
                <div class="about-qrcode_text">
                  <p>Open WeChat and scan <i class="iconfont icon-scan"></i></p>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="Scientific research" name="ScientificResearch">
            <p class="about-title">
              <span class="about-title__name">Dissertation publications</span>
            </p>
            <div class="about-publications__list">
              <div>
                <div
                  v-for="(post, index) in postList"
                  :key="index"
                  class="about-publications__item"
                >
                  <a
                    :href="post.url"
                    class="about-publications__title"
                    target="_blank"
                  >
                    {{ post.title }}
                  </a>
                </div>
              </div>
              <div class="about-publications__pagination">
                <el-pagination
                  :current-page.sync="pageInfo.page"
                  :page-size="pageInfo.pageSize"
                  :total="pageInfo.total"
                  layout="total, prev, pager, next"
                  @current-change="handleCurrentChange"
                >
                </el-pagination>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="Contact address" lazy name="ContactAddress">
            <div class="about-map">
              <div class="about-map__map">
                <iframe
                  src="/map-ecust.html"
                  style="width: 100%; height: 100%; border: none"
                ></iframe>
              </div>
              <div class="about-map__desc">
                <p class="about-map__desc__text">
                  Address: Shanghai Meilong Road No. 130
                </p>
                <p class="about-map__desc__text">Postcode: 200237</p>
                <p class="about-map__desc__text">TEL:+86(021)64253832</p>
                <p class="about-map__desc__text">FAX:021-64253832</p>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="Technical support" lazy name="TechnicalSupport">
            <div class="about-map">
              <div class="about-map__map">
                <iframe
                  src="/map-minglead.html"
                  style="width: 100%; height: 100%; border: none"
                ></iframe>
              </div>
              <div class="about-map__desc">
                <p class="about-map__desc__text">
                  Address：Room 301, 3rd floor, No. 894,<br />
                  Tianhe North Road,Guangzhou
                </p>
                <p class="about-map__desc__text">Postcode：510000</p>
                <p class="about-map__desc__text">TEL：020-85219688</p>
                <p class="about-map__desc__text">Email：gene@minglead.com</p>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
const postList = [
  {
    title:
      "Yao LL, Ye BC. Reciprocal Regulation of GlnR and PhoP in Response to Nitrogen and Phosphate Limitations in Saccharopolyspora erythraea. Appl Environ Microbiol. 2015;82(1):409-420.",
    url: "https://journals.asm.org/doi/10.1128/aem.02960-15",
  },
  {
    title:
      "Xu Y, You D, Yao LL, Chu X, Ye BC. Phosphate regulator PhoP directly and indirectly controls transcription of the erythromycin biosynthesis genes in Saccharopolyspora erythraea. Microb Cell Fact. 2019;18(1):206.",
    url: "https://microbialcellfactories.biomedcentral.com/articles/10.1186/s12934-019-1258-y",
  },
  {
    title:
      "Yao LL, Liao CH, Huang G, et al. GlnR-mediated regulation of nitrogen metabolism in the actinomycete Saccharopolyspora erythraea. Appl Microbiol Biotechnol. 2014;98(18):7935-7948.",
    url: "https://link.springer.com/article/10.1007/s00253-014-5878-1",
  },
  {
    title:
      "You D, Yin BC, Li ZH, et al. Sirtuin-dependent reversible lysine acetylation of glutamine synthetases reveals an autofeedback loop in nitrogen metabolism. Proc Natl Acad Sci U S A. 2016;113(24):6653-6658.",
    url: "https://www.pnas.org/doi/full/10.1073/pnas.1525654113",
  },
  {
    title:
      "Xu JY, Zhao L, Xu Y, et al. Dynamic Characterization of Protein and Posttranslational Modification Levels in Mycobacterial Cholesterol Catabolism. mSystems. 2020;5(1):e00424-19.",
    url: "https://journals.asm.org/doi/10.1128/msystems.00424-19",
  },
  {
    title:
      "Xu JY, Xu Y, Xu Z, et al. Protein Acylation is a General Regulatory Mechanism in Biosynthetic Pathway of Acyl-CoA-Derived Natural Products. Cell Chem Biol. 2018;25(8):984-995.e6.",
    url: "https://www.sciencedirect.com/science/article/pii/S2451945618301521?via%3Dihub",
  },
  {
    title:
      "Xu JY, Zhao L, Liu X, et al. Characterization of the Lysine Acylomes and the Substrates Regulated by Protein Acyltransferase in Mycobacterium smegmatis. ACS Chem Biol. 2018;13(6):1588-1597.",
    url: "https://pubs.acs.org/doi/10.1021/acschembio.8b00213",
  },
  {
    title:
      "You D, Wang MM, Ye BC. Acetyl-CoA synthetases of Saccharopolyspora erythraea are regulated by the nitrogen response regulator GlnR at both transcriptional and post-translational levels. Mol Microbiol. 2017;103(5):845-859.",
    url: "https://onlinelibrary.wiley.com/doi/10.1111/mmi.13595",
  },
  {
    title:
      "Xu Y, Li YX, Ye BC. Lysine propionylation modulates the transcriptional activity of phosphate regulator PhoP in Saccharopolyspora erythraea. Mol Microbiol. 2018;110(4):648-661.",
    url: "https://onlinelibrary.wiley.com/doi/10.1111/mmi.14122",
  },
  {
    title:
      "Liu WB, Liu XX, Shen MJ, She GL, Ye BC. The Nitrogen Regulator GlnR Directly Controls Transcription of the prpDBC Operon Involved in Methylcitrate Cycle in Mycobacterium smegmatis. J Bacteriol. 2019;201(8):e00099-19. ",
    url: "https://journals.asm.org/doi/10.1128/jb.00099-19",
  },
  {
    title:
      "You D, Zhang BQ, Ye BC. GntR Family Regulator DasR Controls Acetate Assimilation by Directly Repressing the acsA Gene in Saccharopolyspora erythraea. J Bacteriol. 2018;200(13):e00685-17. ",
    url: "https://europepmc.org/article/PMC/5996686",
  },
  {
    title:
      "Liao CH, Yao L, Xu Y, Liu WB, Zhou Y, Ye BC. Nitrogen regulator GlnR controls uptake and utilization of non-phosphotransferase-system carbon sources in actinomycetes. Proc Natl Acad Sci U S A. 2015;112(51):15630-15635.",
    url: "https://www.pnas.org/doi/full/10.1073/pnas.1508465112",
  },
  {
    title:
      "Liao CH, Yao LL, Ye BC. Three genes encoding citrate synthases in Saccharopolyspora erythraea are regulated by the global nutrient-sensing regulators GlnR, DasR, and CRP. Mol Microbiol. 2014; 94(5):1065-1084.",
    url: "https://onlinelibrary.wiley.com/doi/10.1111/mmi.12818",
  },
  {
    title:
      "Xu Y, Liao CH, Yao LL, Ye X, Ye BC. GlnR and PhoP Directly Regulate the Transcription of Genes Encoding Starch-Degrading, Amylolytic Enzymes in Saccharopolyspora erythraea. Appl Environ Microbiol. 2016;82(23):6819-6830.",
    url: "https://journals.asm.org/doi/10.1128/aem.02117-16",
  },
  {
    title:
      "Xu Z, Liu Y, Ye BC. PccD Regulates Branched-Chain Amino Acid Degradation and Exerts a Negative Effect on Erythromycin Production in Saccharopolyspora erythraea. Appl Environ Microbiol. 2018;84(8):e00049-18. ",
    url: "https://journals.asm.org/doi/10.1128/aem.00049-18",
  },
  {
    title:
      "Liu XX, Liu WB, Ye BC. Regulation of a Protein Acetyltransferase in Myxococcus xanthus by the Coenzyme NADP. J Bacteriol. 2015;198(4):623-632. ",
    url: "https://journals.asm.org/doi/10.1128/jb.00661-15",
  },
  {
    title:
      "Liu XX, Liu WB, Ye BC. Regulation of a Protein Acetyltransferase in Myxococcus xanthus by the Coenzyme NADP. J Bacteriol. 2015;198(4):623-632. ",
    url: "https://pubs.acs.org/doi/10.1021/acs.jproteome.6b00131",
  },
  {
    title:
      "Sun M, Xu J, Wu Z, et al. Characterization of Protein Lysine Propionylation in Escherichia coli: Global Profiling, Dynamic Change, and Enzymatic Regulation. J Proteome Res. 2016;15(12):4696-4708.",
    url: "https://pubs.acs.org/doi/10.1021/acs.jproteome.6b00798",
  },
  {
    title:
      "You D, Wang MM, Ye BC. Acetyl-CoA synthetases of Saccharopolyspora erythraea are regulated by the nitrogen response regulator GlnR at both transcriptional and post-translational levels. Mol Microbiol. 2017;103(5):845-859.",
    url: "https://onlinelibrary.wiley.com/doi/10.1111/mmi.13595",
  },
  {
    title:
      "Xu JY, Xu Y, Xu Z, et al. Protein Acylation is a General Regulatory Mechanism in Biosynthetic Pathway of Acyl-CoA-Derived Natural Products. Cell Chem Biol. 2018;25(8):984-995.e6.",
    url: "https://www.cell.com/cell-chemical-biology/pdf/S2451-9456(18)30152-1.pdf",
  },
  {
    title:
      "Xu JY, Xu Y, Chu X, Tan M, Ye BC. Protein Acylation Affects the Artificial Biosynthetic Pathway for Pinosylvin Production in Engineered E. coli. ACS Chem Biol. 2018;13(5):1200-1208.",
    url: "https://pubs.acs.org/doi/10.1021/acschembio.7b01068",
  },
  {
    title:
      "Xu JY, Xu Z, Liu X, Tan M, Ye BC. Protein Acetylation and Butyrylation Regulate the Phenotype and Metabolic Shifts of the Endospore-forming Clostridium acetobutylicum. Mol Cell Proteomics. 2018;17(6):1156-1169.",
    url: "https://www.sciencedirect.com/science/article/pii/S1535947620322386?via%3Dihub",
  },
  {
    title:
      "You D, Wang MM, Yin BC, Ye BC. Precursor Supply for Erythromycin Biosynthesis: Engineering of Propionate Assimilation Pathway Based on Propionylation Modification. ACS Synth Biol. 2019;8(2):371-380.",
    url: "https://pubs.acs.org/doi/10.1021/acssynbio.8b00396",
  },
  {
    title:
      "Xu Z, Wang M, Ye BC. TetR Family Transcriptional Regulator PccD Negatively Controls Propionyl Coenzyme A Assimilation in Saccharopolyspora erythraea. J Bacteriol. 2017;199(20):e00281-17.",
    url: "https://journals.asm.org/doi/10.1128/jb.00281-17",
  },
  {
    title:
      "You D, Zhang BQ, Ye BC. GntR Family Regulator DasR Controls Acetate Assimilation by Directly Repressing the acsA Gene in Saccharopolyspora erythraea. J Bacteriol. 2018;200(13):e00685-17. ",
    url: "https://journals.asm.org/doi/10.1128/jb.00685-17",
  },
  {
    title:
      "Xu Z, Liu Y, Ye BC. PccD Regulates Branched-Chain Amino Acid Degradation and Exerts a Negative Effect on Erythromycin Production in Saccharopolyspora erythraea. Appl Environ Microbiol. 2018;84(8):e00049-18. ",
    url: "https://journals.asm.org/doi/10.1128/aem.00049-18",
  },
  {
    title:
      "You D, Yao LL, Huang D, Escalante-Semerena JC, Ye BC. Acetyl coenzyme A synthetase is acetylated on multiple lysine residues by a protein acetyltransferase with a single Gcn5-type N-acetyltransferase (GNAT) domain in Saccharopolyspora erythraea. J Bacteriol. 2014;196(17):3169-3178.",
    url: "https://journals.asm.org/doi/10.1128/jb.01961-14",
  },
  {
    title:
      "You D, Wang MM, Ye BC. Acetyl-CoA synthetases of Saccharopolyspora erythraea are regulated by the nitrogen response regulator GlnR at both transcriptional and post-translational levels. Mol Microbiol. 2017;103(5):845-859.",
    url: "https://onlinelibrary.wiley.com/doi/10.1111/mmi.13595",
  },
  {
    title:
      "Liu Y, Wei WP, Ye BC. High GC Content Cas9-Mediated Genome-Editing and Biosynthetic Gene Cluster Activation in Saccharopolyspora erythraea. ACS Synth Biol. 2018;7(5):1338-1348.",
    url: "https://pubs.acs.org/doi/10.1021/acssynbio.7b00448",
  },
  {
    title:
      "Xu Z, You D, Tang LY, Zhou Y, Ye BC. Metabolic Engineering Strategies Based on Secondary Messengers (p)ppGpp and C-di-GMP To Increase Erythromycin Yield in Saccharopolyspora erythraea. ACS Synth Biol. 2019;8(2):332-345.",
    url: "https://pubs.acs.org/doi/10.1021/acssynbio.8b00372",
  },
  {
    title:
      "Xu JY, Xu Y, Xu Z, et al. Protein Acylation is a General Regulatory Mechanism in Biosynthetic Pathway of Acyl-CoA-Derived Natural Products. Cell Chem Biol. 2018;25(8):984-995.e6.",
    url: "https://www.sciencedirect.com/science/article/pii/S2451945618301521?via%3Dihub",
  },
  {
    title:
      "You D, Wang MM, Yin BC, Ye BC. Precursor Supply for Erythromycin Biosynthesis: Engineering of Propionate Assimilation Pathway Based on Propionylation Modification. ACS Synth Biol. 2019;8(2):371-380.",
    url: "https://pubs.acs.org/doi/10.1021/acssynbio.8b00396",
  },
  {
    title:
      "Xu Z, Liu Y, Ye BC. PccD Regulates Branched-Chain Amino Acid Degradation and Exerts a Negative Effect on Erythromycin Production in Saccharopolyspora erythraea. Appl Environ Microbiol. 2018;84(8):e00049-18. ",
    url: "https://journals.asm.org/doi/10.1128/aem.00049-18",
  },
  {
    title:
      "Xu Z, Wang M, Ye BC. TetR Family Transcriptional Regulator PccD Negatively Controls Propionyl Coenzyme A Assimilation in Saccharopolyspora erythraea. J Bacteriol. 2017;199(20):e00281-17.",
    url: "https://journals.asm.org/doi/10.1128/jb.00281-17",
  },
  {
    title:
      "Pei JF, Li YX, Tang H, Wei W, Ye BC. PhoP- and GlnR-mediated regulation of metK transcription and its impact upon S-adenosyl-methionine biosynthesis in Saccharopolyspora erythraea. Microb Cell Fact. 2022;21(1):120. ",
    url: "https://link.springer.com/article/10.1186/s12934-022-01846-w",
  },
  {
    title:
      "Xu Y, You D, Yao LL, Chu X, Ye BC. Phosphate regulator PhoP directly and indirectly controls transcription of the erythromycin biosynthesis genes in Saccharopolyspora erythraea. Microb Cell Fact. 2019;18(1):206.",
    url: "https://microbialcellfactories.biomedcentral.com/articles/10.1186/s12934-019-1258-y",
  },
  {
    title:
      "Pei JF, Li YX, Tang H, Wei W, Ye BC. PhoP- and GlnR-mediated regulation of metK transcription and its impact upon S-adenosyl-methionine biosynthesis in Saccharopolyspora erythraea. Microb Cell Fact. 2022;21(1):120. ",
    url: "https://link.springer.com/article/10.1186/s12934-022-01846-w",
  },
  {
    title:
      "Xu Y, Li YX, Ye BC. Lysine propionylation modulates the transcriptional activity of phosphate regulator PhoP in Saccharopolyspora erythraea. Mol Microbiol. 2018;110(4):648-661. ",
    url: "https://onlinelibrary.wiley.com/doi/pdf/10.1111/mmi.14122",
  },
  {
    title:
      "Fu Y, Dong YQ, Shen JL, Yin BC, Ye BC, You D. A meet-up of acetyl phosphate and c-di-GMP modulates BldD activity for development and antibiotic production. Nucleic Acids Res. 2023;51(13):6870-6882.",
    url: "https://academic.oup.com/nar/article/51/13/6870/7191421",
  },
  {
    title:
      "Xu Z, You D, Tang LY, Zhou Y, Ye BC. Metabolic Engineering Strategies Based on Secondary Messengers (p)ppGpp and C-di-GMP To Increase Erythromycin Yield in Saccharopolyspora erythraea. ACS Synth Biol. 2019;8(2):332-345.",
    url: "https://pubs.acs.org/doi/10.1021/acssynbio.8b00372",
  },
  {
    title:
      "Tschowri N, Schumacher MA, Schlimpert S, et al. Tetrameric c-di-GMP mediates effective transcription factor dimerization to control Streptomyces development. Cell. 2014;158(5):1136-1147.",
    url: "https://www.sciencedirect.com/science/article/pii/S0092867414009362?via%3Dihub",
  },
  {
    title:
      "Xu Z, You D, Tang LY, Zhou Y, Ye BC. Metabolic Engineering Strategies Based on Secondary Messengers (p)ppGpp and C-di-GMP To Increase Erythromycin Yield in Saccharopolyspora erythraea. ACS Synth Biol. 2019;8(2):332-345.",
    url: "https://pubs.acs.org/doi/10.1021/acssynbio.8b00372",
  },
];
export default {
  name: "AboutView",
  data() {
    return {
      activeName: "AboutTheResearchTeam",
      pageInfo: {
        page: 1,
        pageSize: 5,
        total: postList.length,
      },
    };
  },
  computed: {
    postList() {
      const start = (this.pageInfo.page - 1) * this.pageInfo.pageSize;
      const end = this.pageInfo.page * this.pageInfo.pageSize;
      return postList.slice(start, end);
    },
  },
  methods: {
    handleTabClick() {},
    handleCurrentChange() {},
  },
};
</script>

<style lang="scss" scoped>
.about {
  padding-bottom: px2rem(100);

  .about-banner {
    display: flex;
    align-items: center;
    height: px2rem(300);
    background-image: url("~@/assets/about/banner.webp");
    background-size: cover;
    background-position: bottom center;

    .about-banner__title {
      color: #fff;
    }
  }

  .about-body {
    padding-top: px2rem(30);
  }

  .about-title {
    display: flex;
    align-items: center;
    border-bottom: px2rem(1) solid #d8d8d8;
    padding-bottom: px2rem(30);
    margin-bottom: px2rem(30);
  }

  .about-divider {
    height: px2rem(50);
    width: 1px;
    background-color: $--border-color-base;
    margin-left: px2rem(26);
    margin-right: px2rem(20);
  }

  .about-qrcode {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &_text {
      margin-top: px2rem(10);
      font-size: px2rem(16);

      .iconfont {
        display: inline-block;
        vertical-align: middle;
        font-size: px2rem(16);
        color: $--color-text-regular;
      }

      p {
        display: inline-block;
        vertical-align: middle;
        color: $--color-text-regular;
      }
    }
  }

  .about-wechat {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .about-wechat__card {
    border: 1px solid $--border-color-base;
    border-radius: $--border-radius-base;
    width: px2rem(320);
    background-image: url("~@/assets/about/wechat.svg");
    background-size: 40%;
    background-repeat: no-repeat;
    background-position: right center;
    overflow: hidden;

    &-body {
      display: flex;
      align-items: center;
      padding: px2rem(10) px2rem(20);
      border-bottom: 1px solid $--border-color-base;

      img {
        width: px2rem(80);
        height: px2rem(80);
      }
    }

    &-title {
      font-size: px2rem(16);
      margin-left: px2rem(10);
    }

    &-footer {
      padding: px2rem(10) px2rem(20);
      color: $--color-text-regular;
      font-size: px2rem(14);
      background-color: #f8f9fa;
    }
  }

  .about-title__name {
    font-size: px2rem(16);
    margin-right: px2rem(30);
    font-weight: bold;
  }

  .about-title__time {
    font-size: px2rem(14);
    color: #999;
    font-weight: normal;
  }

  .about-text {
    font-size: px2rem(14);
    color: #666;
    line-height: 2;
    text-indent: px2rem(28);
    margin-bottom: px2rem(30);
  }

  .about-publications__list {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: px2rem(400);
  }

  .about-publications__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: px2rem(14);
    margin-bottom: px2rem(30);

    &:last-child {
      margin-bottom: 0;
    }
  }

  .about-publications__title {
    line-height: 1.5;
  }

  .about-publications__pagination {
    margin-top: px2rem(30);
    display: flex;
  }

  .about-map {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: px2rem(40) 0;

    .about-map__map {
      width: px2rem(600);
      height: px2rem(400);
      background-color: #f5f5f5;
    }

    .about-map__desc {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin: 0 auto;
      justify-content: center;
      font-size: px2rem(16);
      line-height: 2.5;

      &__text {
        color: #666666;
      }
    }
  }
}

::v-deep .el-tabs__header {
  margin: 0;
}

::v-deep .el-tabs__content {
  border: 1px solid #e4e7ed;
  border-top: none;
  padding: px2rem(30);
}
</style>
